import axios from 'axios';

// Supprime les / à la fin
const trimSlash = (s = '') => s.replace(/\/+$/, '');

// ---- ENV CONFIG ----
// IMPORTANT : doit exister dans .env.production
const BASE = trimSlash(process.env.VUE_APP_API_URL || 'https://api.administration.cap.tn');

// Si tu veux préfixer par /api → tu le mets ici
const PREFIX = trimSlash(process.env.VUE_APP_API_PREFIX || 'api');

// Base URL finale : https://api.administration.cap.tn/api
const API_BASE = PREFIX ? `${BASE}/${PREFIX}` : BASE;

console.log("🔗 API BASE URL =", API_BASE);

// ---- AXIOS INSTANCE ----
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  timeout: 20000,
});

// ---- REQUEST INTERCEPTOR ----
// Ajoute automatiquement le token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (err) => {
  return Promise.reject(err);
});

// ---- RESPONSE INTERCEPTOR ----
// Si token expiré → suppression
api.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      console.warn("Token expiré → déconnexion.");
      localStorage.removeItem('token');
      
      // Redirection vers la page de connexion sans message
      if (window.location.pathname !== '/sign-in') {
        window.location.href = '/sign-in';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
